module.exports = __webpack_public_path__ + "img/group1.c847d265.svg";